import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import MarkdownWrapper from '../utils/markdown-wrapper'
import { saveNavTheme } from '../../reducers/nav'
import { ReactComponent as Marker } from '../../assets/svgs/underline-03.svg'

const CharacterReflection = ({ dispatch, chapter, status }) => {
    const [enableLinks, setEnableLinks] = useState(false)
    useEffect(() => {
        if (status === 'ACTIVE') {
            dispatch(saveNavTheme('grey'))
            setEnableLinks(true)
        } else if (status === 'PREVIOUS' || status === 'NEXT') {
            setTimeout(() => {
                setEnableLinks(false)
            }, 1000)
        }
    }, [status])

    if (!chapter || status === 'OFF') {
        return null
    }
    return (
        <div className={`chapter-container ${status.toLowerCase()} ${enableLinks ? '' : 'disable-links'} moment-of-reflection`}>
            <div className="mor-background">
                <img src="/mor-bg-01.png" alt="Animater Background" role="presentation" />
            </div>
            <div className="mor-content container">
                <div className="title-stroke">
                    <h2 className="mor-title">Think About It</h2>
                    <Marker />
                </div>
                <div className="mor-text">
                    <MarkdownWrapper content={chapter.content} />
                </div>
            </div>
        </div>
    )
}

export default connect()(CharacterReflection)
